import { InventoryItem, InventoryPoolRole, InventoryRule } from 'inventory/inventoryService'

export type WireCountingType = 'Venue' | 'Gate'

export type CountingType = 'wholeTimeSlot' | 'arrivalOnly'

export const countingTypeFromWire = (wire: WireCountingType): CountingType =>
    wire === 'Gate' ? 'arrivalOnly' : 'wholeTimeSlot'

export const countingTypeToWire = (counting: CountingType): WireCountingType =>
    counting === 'arrivalOnly' ? 'Gate' : 'Venue'

export type CapacityRole = InventoryPoolRole

export type CapacityHealthWire = 'ok' | 'no_default_rule'

export interface CapacitySummary extends InventoryItem {
    version?: string
    health?: CapacityHealthWire
}

export type CapacityRule = InventoryRule

export interface CapacityDetails extends CapacitySummary {
    availabilityRules: CapacityRule[]
}

export type CapacityWriteBody = CapacitySummary

export type NewCapacityBody = Omit<CapacitySummary, 'id'>

export type LimitState = { kind: 'number'; value: number } | { kind: 'noLimit' } | { kind: 'closed' }

export const LIMIT_MAX = 100000

export const toLimitState = (value: number | null | undefined): LimitState => {
    if (value === null || value === undefined) {
        return { kind: 'noLimit' }
    }
    if (value === 0) {
        return { kind: 'closed' }
    }
    return { kind: 'number', value }
}

export const fromLimitState = (state: LimitState): number | null => {
    switch (state.kind) {
        case 'noLimit':
            return null
        case 'closed':
            return 0
        default:
            return state.value
    }
}

export const parseLimitInput = (text: string): LimitState | 'invalid' => {
    const trimmed = text.trim()
    if (trimmed === '') {
        return { kind: 'noLimit' }
    }
    if (!/^\d+$/.test(trimmed)) {
        return 'invalid'
    }
    const value = Number(trimmed)
    if (value > LIMIT_MAX) {
        return 'invalid'
    }
    return toLimitState(value)
}

export const limitStatesEqual = (a: LimitState, b: LimitState): boolean =>
    a.kind === b.kind && (a.kind !== 'number' || b.kind !== 'number' || a.value === b.value)

export type CapacityHealth = 'ok' | 'noDefaultRule' | 'unknown'
